<ion-icon name="alert-circle-outline" color="danger" style="font-size: 4.5em;"></ion-icon>
<h2> {{ message | translate}} </h2>
